module.exports = __webpack_public_path__ + "img/gg.e3b903b8.jpg";